import { render, staticRenderFns } from "./CardComentariosTitulo.vue?vue&type=template&id=7a8cf373&scoped=true"
import script from "./CardComentariosTitulo.vue?vue&type=script&lang=js"
export * from "./CardComentariosTitulo.vue?vue&type=script&lang=js"
import style0 from "./CardComentariosTitulo.vue?vue&type=style&index=0&id=7a8cf373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8cf373",
  null
  
)

export default component.exports